import axios from "axios";

export default axios.create({
  /*
  baseURL: "https://testing-talking-camel.addai.cz",
  baseURL: "https://talking-camel.addai.cz",
  baseURL: "https://airbank-talking-camel.addai.cz",
  */
 baseURL: "https://airbank-talking-camel.addai.cz/tc",
 headers: {
    'Content-Type': "application/json",
  }
});
